import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';

const eopsApiBaseUrl = "https://eopsapi.pitc.com.pk/";

const initialState = {
    data: [],
    currentPage: 1,
    pageSize: 20,
    dateFrom: '',
    dateTo: '',
    applicationProgressId: '',
    objectionStatus: '',
    filterByOfficeCode: '',
    loadFrom: '',
    loadTo: '',
    userId: '',
    totalPages: null,
    totalRecords: null,
    isLoading: false,
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchPaginatedAdvancePaymentNormal = createAsyncThunk(
    'billingAndCollection/fetchAdvancePaymentNormal',
    async ({ page, pageSize, dateFrom, dateTo, applicationProgressId, objectionStatus, filterByOfficeCode, loadFrom, loadTo, officeCode }, { getState }) => {
        const { auth } = getState();
        const { token, code, hierarchy, showAllApplicationsFlag, csc, userId,roleId} = auth;

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("pageNumber", String(page || 1));
        formdata.append("pageSize", String(pageSize || 500));
        formdata.append("officeCode", code == 10 ? officeCode : code);
        formdata.append("officeLevel", String(hierarchy || 2));
        formdata.append("overDueFlag", "0");
        formdata.append("dateFrom", dateFrom || '');
        formdata.append("dateTo", dateTo || '');
        formdata.append("applicationProgressId", applicationProgressId || '');
        formdata.append("userId", roleId == 113 || roleId == 1146 ? userId : '');
        formdata.append("assignedTo", '');

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `advancePayment/getAllApplications`, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Stats API issue!');
        }

        const result = await response.json();

        if (result.status !== "200" && result.status !== "400") {
            throw new Error(result.message, 'printing error message' || 'Unable to fetch stats!');
        }

        return result;
    }
);

const advancePaymentNormalSlice = createSlice({
    name: 'advancePaymentNormalPaginated',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.currentPage += 1;
        },
        previousPage(state) {
            if (state.currentPage > 1) {
                state.currentPage -= 1;
            }
        },
        filterProgressId(state, action) {
            state.applicationProgressId = action.payload
        },
        resetProgressIdFilter(state) {
            state.applicationProgressId = ''
        },
        filterObjectionStatus(state, action) {
            state.objectionStatus = action.payload
        },
        resetObjectionStatusFilter(state) {
            state.objectionStatus = ''
        },
        filterDateFrom(state, action) {
            state.dateFrom = action.payload
        },
        filterDateTo(state, action) {
            state.dateTo = action.payload
        },
        resetDateFilter(state) {
            state.dateFrom = ''
            state.dateTo = ''
        },
        firstPage(state) {
            state.currentPage = 1;
        },
        lastPage(state, action) {
            state.currentPage = action.payload;
        },
        resetState(state) {
            state.data = []
            state.currentPage = 1
            state.pageSize = 20
            state.dateFrom = ''
            state.dateTo = ''
            state.applicationProgressId = ''
            state.objectionStatus = ''
            state.filterByOfficeCode = ''
            state.loadFrom = ''
            state.loadTo = ''
            state.userId = ''
            state.totalPages = null
            state.totalRecords = null
            state.isLoading = false
            state.error = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedAdvancePaymentNormal.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedAdvancePaymentNormal.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload?.data) {
                    state.data = action.payload.data;
                } else {
                    state.data = []
                }
                if (action.payload?.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1
                }
                state.totalRecords = action.payload?.totalRecords;
                state.error = null;
            })
            .addCase(fetchPaginatedAdvancePaymentNormal.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                state.totalPages = null;
                state.totalRecords = null;
            });
    },
});

export const { nextPage, previousPage, firstPage, lastPage, filterProgressId, filterObjectionStatus, filterDateFrom, filterDateTo, resetProgressIdFilter, resetObjectionStatusFilter, resetDateFilter, resetState } = advancePaymentNormalSlice.actions;

export default advancePaymentNormalSlice.reducer;
